import { Suspense, useState } from "react";
import { observer } from "mobx-react-lite";
import { Spin } from "antd";
import { useStore } from "../../stores/root-store-context";
import FreezeWarningModal from "./FreezeWarningModal";
import Offcanvas from "./Offcanvas";
import MouseCursor from "./MouseCursor";
import ERPHeader from "./header/ERPHeader";
import Search from "./Search";
import Breadcrumb from "./Breadcrumb";
import BackToTop from "../elements/BackToTop";

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface ERPLayoutProps {
  breadcrumbTitle?: string;
  breadcrumbItems?: BreadcrumbItem[];
  children: React.ReactNode;
}

const ERPLayout = observer(({ 
  breadcrumbTitle, 
  breadcrumbItems, 
  children 
}: ERPLayoutProps) => {
    const { applicationStore } = useStore();

    const [isOffCanvas, setOffCanvas] = useState(false);
    const handleOffCanvas = () => setOffCanvas(!isOffCanvas);

    const [isSearch, setSearch] = useState(false);
    const handleSearch = () => setSearch(!isSearch);

    return (
        <>
            <Spin spinning={applicationStore.isLoading} className="layout">
                <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                    <FreezeWarningModal />
                    <div>
                        <MouseCursor />
                        <Offcanvas isOffCanvas={isOffCanvas} handleOffCanvas={handleOffCanvas} />

                        <Suspense fallback={<div>Loading...</div>}>
                            <ERPHeader 
                                isOffCanvas={isOffCanvas} 
                                handleOffCanvas={handleOffCanvas} 
                                isSearch={isSearch} 
                                handleSearch={handleSearch} 
                            />
                        </Suspense>
                        
                        <Search isSearch={isSearch} handleSearch={handleSearch} />

                        {breadcrumbTitle && 
                            <Breadcrumb 
                                breadcrumbTitle={breadcrumbTitle} 
                                breadcrumbItems={breadcrumbItems} 
                            />
                        }

                        {children}
                    </div>
                    <div className="footer-simple" style={{ marginTop: "auto", padding: "20px 0", textAlign: "center", backgroundColor: "#f5f5f5" }}>
                        <div className="container">
                            <p>© {new Date().getFullYear()} SunPoint. All rights reserved.</p>
                        </div>
                    </div>
                    <BackToTop />
                </div>
            </Spin>
        </>
    );
});

export default ERPLayout;